import { UploadCardDto } from './useUploadCardActions';

/**
 * Reads the published content title from untyped publishData when available.
 */
export function getUploadTitle(upload: UploadCardDto): string | undefined {
  const title = upload.publishData?.title;
  return typeof title === 'string' && title.trim().length > 0 ? title.trim() : undefined;
}
